import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MomentService } from 'src/app/service/shared/moment/moment.service';
import { JobPointeTransferService } from '../../job-pointe-transfer/job-pointe-transfer.service';
import { JobPointeService } from 'src/app/service/job-pointe/job-pointe.service';
import { PermissionsService } from 'src/app/service/auth/permissions.service';
@Component({
  selector: 'app-job-board-profile-sidenav',
  templateUrl: './job-board-profile-sidenav.component.html',
  styleUrls: ['./job-board-profile-sidenav.component.scss'],
})
export class JobBoardProfileSidenavComponent implements OnChanges {
  @Input() employeeData: any;
  @Input() tagData: any;
  @Output() public closeEmployeeSideNav = new EventEmitter<any>();
  jobBoardTagAssignments: Array<any> = [];
  tagAssignments: Array<any> = [];
  employeeNoteLogs: Array<{ id: number; note: string; userId: number; createdAt: string; updatedAt: string }> = [];
  latestNote: String = ''
  otherNotes: Array<{ id: number; note: string; userId: number; createdAt: string; updatedAt: string }> = [];

  constructor(
    private momentService: MomentService,
    private jobPointeTransferService: JobPointeTransferService,
    private jobPointeService: JobPointeService,
    private permissionsService: PermissionsService,
  ) { }

  ngOnChanges() {
    if (this.employeeData?.employeeNoteLogs?.length) {
      this.employeeNoteLogs = [...this.employeeData.employeeNoteLogs].sort((a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      this.latestNote = this.employeeNoteLogs[0].note;
      this.otherNotes = this.employeeNoteLogs.slice(1);
    } else {
      this.latestNote = '';
      this.otherNotes = [];
    }

    this.tagAssignments = this.tagData;
  }

  removeCardTag(tagAssignment) {
    this.jobPointeService.delete['jobBoardTagAssignment']({
      id: tagAssignment.id,
    }).subscribe(
      res => {
        if (res.success) {
          this.tagAssignments = this.tagAssignments.filter(ta => ta.id != tagAssignment.id);
        }
      },
      err => {
        if (err.status == 404) {
          this.tagAssignments = this.tagAssignments.filter(ta => ta.id != tagAssignment.id);
        }
      },
    );
  }

  formatDate(date: string) {
    return date ? this.momentService.formateDate(date) : '';
  }

  async viewProfile() {
    this.jobPointeTransferService.selectedRowSource.next(this.employeeData);
    this.jobPointeTransferService.modalIsOpenSource.next(true);
  }

  closeEmployeeSideNavBar() {
    this.closeEmployeeSideNav.emit(false);
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      job_board_attributes: 'job_board_attributes',
      job_pointe_employees: 'job_pointe_employees',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }
}
